import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { VerifyAccountComponent } from './pages/verify-account/verify-account.component';
import { LoginComponent } from './pages/login/login.component';
import { RegisterComponent } from './pages/register/register.component';
import { SetPasswordComponent } from './pages/set-password/set-password.component';
import { RecoverPasswordComponent } from './pages/recover-password/recover-password.component';
import { AuthGuard } from './helpers/guards/auth.guard';
import { GroupGuard } from './helpers/guards/group.guard';
import { UploadPricesComponent } from './pages/upload-prices/upload-prices.component';
import { LoginPricesComponent } from './pages/login-prices/login-prices.component';

const routes: Routes = [
  {
    path: 'gasprecio',
    loadChildren: () => import('src/app/modules/gasprecio/gasprecio.module').then(m => m.GasPrecioModule),
    // GroupGuard: sin el id del grupo resuelto, los gates por grupo del tablero
    // (Reporte Cruzado, Inventario…) quedan apagados hasta recargar. Ver el guard.
    canActivate: [AuthGuard, GroupGuard]
  },
  {
    path: 'estacion',
    loadChildren: () => import('src/app/modules/station/station.module').then(m => m.StationModule),
    canActivate: [AuthGuard]
  },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'verify_account', component: VerifyAccountComponent },
  { path: 'login', component: LoginComponent },
  { path: 'precios/login', component: LoginPricesComponent },
  { path: 'precios/:idStation', component: UploadPricesComponent },
  { path: 'set_password', component: SetPasswordComponent },
  { path: 'recover_password', component: RecoverPasswordComponent },
  { path: 'register', component: RegisterComponent },
  // Ruta desconocida (link viejo, returnUrl de una vista que ya no existe): al
  // monitor en vez de la página 404 (revisión MOBICO 13-oct: «esa pantalla no
  // puede salir»). Sin sesión, AuthGuard la manda al login.
  { path: '**', redirectTo: 'gasprecio/monitor' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    // Los módulos perezosos (gasprecio, estación) se descargan en segundo plano
    // en cuanto la primera vista está pintada. Así, mientras el usuario escribe
    // sus credenciales, el bundle del portal ya quedó listo y al autenticarse
    // la navegación es inmediata en vez de esperar un chunk de varios MB.
    preloadingStrategy: PreloadAllModules
})],
  exports: [RouterModule]
})
export class AppRoutingModule { }